<template>
  <v-card class="mx-auto" elevation="6">
    <v-toolbar color="secondary" dark>
      <v-toolbar-title>{{ queue.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="red"
        v-if="user.permissions.admin"
        @click="deleteQueue"
        small
        fab
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="queue.agents"
        :items-per-page="-1"
        :hide-default-footer="true"
      >
        <template v-slot:[`item.image`]="{ item }">
          <div class="image">
            <img :src="getImage(item)" alt="" />
          </div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.first_name }} {{ item.last_name }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="deleteAgent(item)"
            >mdi-delete</v-icon
          >
        </template>
      </v-data-table>
      <agent-selector
        :agents="agents"
        :slackMap="slackMap"
        :usedAgents="queue.agents"
        @selectedAgent="selectedAgent($event, queue)"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import AgentSelector from "@/components/AgentSelector.vue";
import axios from "@/plugins/axios";
export default {
  components: {
    AgentSelector,
  },
  props: {
    queue: {
      type: Object,
    },
    agents: {
      type: Array,
    },
    slackMap: {
      type: Object,
    },
  },
  data() {
    return {
      user: {},
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "image",
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    selectedAgent(agent, queue) {
      console.log(agent);
      console.log(queue);
      axios
        .post("/api/v1/queues/add-agent", {
          queue: queue.id,
          agent: agent.email,
        })
        .then((res) => {
          console.log(res.data);
          this.$emit("refreshRequest", true);
        });
    },
    deleteQueue() {
      axios.post("/api/v1/queues/delete", { queue: this.queue.id }).then(() => {
        this.$emit("refreshRequest", true);
      });
    },
    deleteAgent(agent) {
      axios
        .post("/api/v1/queues/remove-agent", {
          queue: this.queue.id,
          agent: agent.email,
        })
        .then((res) => {
          this.$emit("refreshRequest", true);
          console.log(res.data);
        });
    },
    getImage(agent) {
      if (!this.slackMap[agent.slack_id]) {
        return "/icon-round.png";
      }
      return this.slackMap[agent.slack_id].image;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-agent {
  height: 60px;
  .select {
    margin-top: 20px;
  }
}
.image {
  align-items: center;
  display: flex;
  align-items: center;
  height: 100%;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
